import { makeStyles } from "@material-ui/core";
import { Colors } from "../../helpers/theme";

const InvestStyle = makeStyles((theme) => ({
  investBtn: {
    background: "rgba(62, 184, 170, 1)",
    color: "white",
    marginTop: "20px",
    "&.disabled": {
      background: Colors.greyLight,
      color: Colors.greySlate
    }
  }
}))

export default InvestStyle;